import React from 'react'
import ApartmentLogin from '../feature/Login/ApartmentLogin'

const ApartmentLoginPage = () => {
  return <ApartmentLogin/>
}

export default ApartmentLoginPage